import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuestions, incrementQuestionViews } from "../../store/questionsSlice";
import {
  Box,
  Typography,
  Avatar,
  Chip,
  Tooltip,
  FormControl,
  Select,
  MenuItem,
  Link
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { getPostedTime } from "../HomeFolder/QA";

const MyQueries = ({ setTotalCount }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { list: questions, loading } = useSelector(
        (state) => state.questions
    );

    const { accounts } = useMsal();
    const loggedInUserId = accounts?.[0]?.idTokenClaims?.oid;
    const loggedInUserName = accounts?.[0]?.name;
    const loggedInUserDesignation =
        accounts?.[0]?.idTokenClaims?.jobTitle || "";
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    useEffect(() => {
        dispatch(fetchQuestions());
    }, [dispatch]);

    const myQuestions = questions.filter(
        (q) => q.user_id === loggedInUserId
    );
    const totalPages = Math.ceil(myQuestions.length / rowsPerPage);

    const paginatedQuestions = myQuestions.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );
    useEffect(() => {
        setTotalCount(myQuestions.length);
    }, [myQuestions.length, setTotalCount]);

    if (loading) {
        return (
            <Box sx={{ textAlign: "center", mt: 6 }}>
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    if (myQuestions.length === 0) {
        return (
            <Box
                sx={{
                    textAlign: "center",
                    mt: 6,
                    p: 4,
                    border: "1px dashed #B980DF",
                    backgroundColor: "#faf5ff",
                }}
            >
                <Typography sx={{ color: "#7500C0", fontWeight: 600 }}>
                    You haven't posted any queries yet.
                </Typography>
            </Box>
        );
    }

    return (
        <>
        <Box>
            {paginatedQuestions.map((q) => (
                <Box
                    key={q.id}
                    sx={{
                        border: "1px solid #B980DF",
                        p: 2,
                        paddingLeft: 0,
                        mb: 2,
                        display: "flex",
                        gap: 2,
                        overflowWrap: "anywhere",
                        wordBreak: "normal" ,
                        minWidth: 0 
                    }}
                >
                    <Box
                        sx={{
                            width: 6,
                            backgroundColor: "#7500C0",
                            height: 40,
                        }}
                    />

                    <Box sx={{ flex: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>
                            <Avatar sx={{ width: 36, height: 36, mr: 1.5 }} />

                            <Box>
                                <Typography fontWeight={600}>
                                    {loggedInUserName}
                                </Typography>
                                <Typography variant="caption" color="#818180">
                                    {loggedInUserDesignation}
                                </Typography>
                            </Box>

                            <Typography
                                variant="caption"
                                color="#757575"
                                sx={{ ml: "auto" }}
                            >
                                Posted {getPostedTime(q.created_at)}
                            </Typography>
                        </Box>

                        {/* Question */}
                        <Typography className="question_typo" 
                            sx={{
                                color: "#7500C0",
                                fontWeight: 600,
                                mb: 1,
                                fontSize: "14px",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                dispatch(incrementQuestionViews(q.id));
                                navigate(`/queries/${q.id}`);
                            }}
                        >
                            Q: {q.body}
                        </Typography>

                        {/* Latest Answer */}
                        <Typography
                            sx={{
                                fontSize: "14px",
                                color: "#6B6B6B",
                                mb: 2,
                            }}
                        >
                            {q.answers_count > 0 ? (
                                <>
                                    <span style={{ marginRight: 4 }}>A:</span>
                                    {q.latest_answer ?? "View answers"}
                                </>
                            ) : (
                                "No answers yet"
                            )}
                        </Typography>

                        {/* Bottom Section */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Box sx={{ display: "flex", gap: 1.5 }}>
                                <Chip label={q.technology} size="small" className="chipsbox"/>
                                <Chip label={q.skill} size="small" className="chipsbox"/>
                            </Box>
                            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                                <Typography fontWeight={600} color="#7500C0">
                                    {q.answers_count}
                                    <span
                                        style={{
                                            color: "#9D9D9B",
                                            fontWeight: 500,
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        answers
                                    </span>
                                </Typography>
                                <Box
                                    sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    }}>
                                <img src={process.env.PUBLIC_URL + "/images/Home/dot_img.png"} alt="views"
                                />
                                </Box>
                                <Tooltip title="Views" arrow
                                    classes={{
                                        tooltip: "custom-tooltip",
                                        arrow: "custom-tooltip-arrow",
                                    }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                        <Box
                                            component="img"
                                            src={process.env.PUBLIC_URL + "/images/Home/view.png"}
                                            alt="views"
                                            sx={{
                                                width: 16,
                                                height: 16,
                                                transition: "0.2s ease",
                                                "&:hover": {
                                                    content: `url(${process.env.PUBLIC_URL + "/images/Home/Visible.png"})`,
                                                },
                                            }}
                                        />
                                        <Typography sx={{ fontSize: "14px", color: "#9D9D9B" }}>
                                           {q.views}
                                        </Typography>
                                    </Box>
                                </Tooltip>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ))}
             {/* PAGINATION */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px",
          mt: 4,
        }}
      >
        <Box
          onClick={() => page > 1 && setPage(page - 1)}
          sx={{
            cursor: page > 1 ? "pointer" : "not-allowed",
          }}
        >
          <img
            src={
              page > 1
                ? process.env.PUBLIC_URL +
                  "/images/Home/leftenabledArrow.png"
                : process.env.PUBLIC_URL +
                  "/images/Home/leftdisabledArrow.png"
            }
            alt="Previous"
            style={{ width: 32, height: 32 }}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          {[...Array(totalPages)].slice(0, 5).map((_, i) => (
            <Typography
              key={i}
              onClick={() => setPage(i + 1)}
              sx={{
                cursor: "pointer",
                fontWeight: page === i + 1 ? 600 : 400,
                color: page === i + 1 ? "#7500C0" : "#000",
                borderBottom:
                  page === i + 1 ? "2px solid #7500C0" : "none",
                px: 1,
              }}
            >
              {i + 1}
            </Typography>
          ))}
        </Box>
        <Box
          onClick={() => page < totalPages && setPage(page + 1)}
          sx={{
            cursor: page < totalPages ? "pointer" : "not-allowed",
          }}
        >
          <img
            src={
              page < totalPages
                ? process.env.PUBLIC_URL +
                  "/images/Home/rightenabledArrow.png"
                : process.env.PUBLIC_URL +
                  "/images/Home/rightdisabledArrow.png"
            }
            alt="Next"
            style={{ width: 32, height: 32 }}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontSize: "14px" }}>
            Items per page
          </Typography>

          <FormControl size="small">
            <Select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(e.target.value);
                setPage(1);
              }}
              sx={{
                width: 70,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderRadius: "0px",
                },
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
    </>
  );
};   

export default MyQueries;